import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-step-completion-selector',
  templateUrl: './step-completion-selector.component.html',
  styleUrls: ['./step-completion-selector.component.scss']
})
export class StepCompletionSelectorComponent implements OnInit {

  stepCompletionsFormArray: FormArray;
  
  @Input() title: string = 'Select Decision';
  @Input() description: string = null;
  @Input() isCancelEnabled: boolean = true;

  @ViewChild('stepCompletionSelectorModal', {static: false}) stepCompletionSelectorModal: ModalDirective;

  selectedStepCompletionIndex: number = 0;
  selectedCallback: (selectedIndex: number) => void = null;

  uniqueID: string = '';

  constructor() { }

  ngOnInit(): void {
    this.selectedStepCompletionIndex = 0;
    this.uniqueID =  Math.random().toString(36).substr(2, 9);
  }

  show(stepCompletionsFormArray: FormArray, selected: (selectedIndex: number) => void) {
    this.stepCompletionsFormArray = stepCompletionsFormArray;
    this.selectedStepCompletionIndex = 0;
    this.selectedCallback = selected;

    this.stepCompletionSelectorModal.show();
  }

  onSubmit() {
    this.stepCompletionSelectorModal.hide();
    if (this.selectedCallback) {
      this.selectedCallback(this.selectedStepCompletionIndex);
    }
  }
}
